import { render, staticRenderFns } from "./AnalyteResultServerTable.vue?vue&type=template&id=70638478"
import script from "./AnalyteResultServerTable.vue?vue&type=script&lang=js"
export * from "./AnalyteResultServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports